import { render } from "./ProviderSetupComponent.vue?vue&type=template&id=528480c8&scoped=true"
import script from "./ProviderSetupComponent.vue?vue&type=script&lang=js"
export * from "./ProviderSetupComponent.vue?vue&type=script&lang=js"

import "./ProviderSetupComponent.vue?vue&type=style&index=0&id=528480c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528480c8"]])

export default __exports__